export default function InitialiseCategoriesCard({ options, useOnboardingStore, existing_categories }) {
  const { categories } = useOnboardingStore();

  const setCategories = useOnboardingStore((state) => state.setCategories);

  const handleCategorySelection = (e) => {
    setCategories(e.target.checked ? [...categories, e.target.value] : categories.filter((cat) => cat !== e.target.value));
  };

  return (
    <div className="initialise-option">
      <div className="icon">
        <i className="fe fe-list" />
      </div>
      <div className="details">
        <h3>Categories</h3>
        <p>A category is a collection of relevant information, it can be used as content for pages, as job search filters, for navigation and etc.</p>
      </div>
      <div className="options">
        {options.map((opt, index) => {
          const id = `initialise-option-categories-${opt.internal_build_name}`;

          const doesExist =
            existing_categories.some((c) => c.url_pattern === opt.url_pattern) ||
            existing_categories.some((c) => c.internal_build_name === opt.internal_build_name);

          return (
            <div className="form-check option" key={index}>
              <input
                className="form-check-input"
                type="checkbox"
                id={id}
                name={id}
                value={opt.internal_build_name}
                onChange={(e) => handleCategorySelection(e)}
                disabled={doesExist}
              />
              <label className="form-check-label option-details" htmlFor={id} style={{ cursor: 'pointer' }}>
                <h4 className="title">
                  {opt.name} {doesExist ? '(Already exists)' : ''}
                </h4>
                <p className="description">{opt.description}</p>
                <p className="url-slug">URL Slug: {opt.url_pattern ?? 'N/A'}</p>
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
